import { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function HealthCheckSaveModal({
  open,
  onClose,
  tagName,
  onSave,
  id,
}) {
  const [editName, setEditName] = useState(tagName);

  useEffect(() => {
    setEditName(tagName);
  }, [tagName]);

  const handleSave = () => {
    onSave(editName, id);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      closeAfterTransition
      sx={{ backdropFilter: "blur(3px)", backgroundColor: "rgba(0,0,0,0.6)" }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 380,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          outline: "none",
        }}
      >
        <Box
          sx={{
            bgcolor: "#1976d2",
            width: 48,
            height: 48,
            borderRadius: "50%",
            margin: "0 auto",
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CheckCircleIcon sx={{ color: "white", fontSize: 32 }} />
        </Box>

        {/* Title */}
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          sx={{ fontWeight: "bold", mb: 3 }}
        >
          Health Check Report saved <br /> Successfully!
        </Typography>

        {/* Rename label */}
        <Typography
          variant="body2"
          sx={{ textAlign: "left", mb: 1, color: "text.secondary" }}
        >
          Rename
        </Typography>

        {/* Input */}
        <TextField
          fullWidth
          value={editName}
          onChange={(e) => setEditName(e.target.value)}
          size="small"
          sx={{ mb: 1 }}
          autoFocus
          inputProps={{ maxLength: 20 }} // MAX = 10
        />
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "right",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {editName?.length}/20
        </Typography>

        {/* Okay button */}
        <Button
          variant="outlined"
          onClick={handleSave}
          fullWidth
          disabled={editName === ""}
        >
          Okay
        </Button>
      </Box>
    </Modal>
  );
}
